
export const projects = [
    {
        title: "BookEnds",
        subtitle: "Bookshelf Creation and Sharing Webapp",
        description: "Using Node.js, MongoDB and Google Books API, users can . Still under development at the moment. The Name was taked from the Simon & Garfunkel album",
        image: "./bookends-shelf.jpg",
        link: "https://github.com/Jake-Knox/bookshelf-app-node",
    },
    {
        title: "Word Dog Online",
        subtitle: "Online Multiplayer Version of my Word Game.",
        description: "Using Node.js and WebSockets to allow users to join game-rooms and play against eachother.",
        image: "./wdo-1.jpg",
        link: "https://github.com/Jake-Knox/online-word-game",
    },
    {
        title: "Blade Runner (Phil Resch) ChatBot",
        subtitle: "Machine learning ChatBot",
        description: "Using a Python Flask backend, machine learning model trained with Python and EJS frontend template. Based loosely on a character from the book.",
        image: "./chatbotApp-1.jpg",
        link: "https://github.com/Jake-Knox/flask-chatbot",
    },
    {
        title: "Word Dog",
        subtitle: "Local Multiplayer Word Game",
        description: "Using vanilla JavaScript, HTML and CSS. Players take turns placing a letter on the game board to spell many words at once.",
        image: "./wd-1.jpg",
        link: "https://github.com/Jake-Knox/word-game",
    },
];

export const skills = [
    "HTML",
    "CSS",
    "JavaScript",
    "C#",
    "Java",
    "Kotlin",
    "Python",
    "PHP",

    "Node.js",
    "React.js",


    "SQL",
    "MongoDB",

    "Agile",
    "Kanban",
    "OOP",
    "Android & iOS",
]

export const testimonials = [
    {
        quote: "Portfolio still under development",
        name: "John Doe",
        company: "Employer - XYZ",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Van_Gogh_-_Starry_Night_-_Google_Art_Project.jpg/970px-Van_Gogh_-_Starry_Night_-_Google_Art_Project.jpg",
    },
    {
        quote: "Please excuse any placeholder text",
        name: "Jane Doe",
        company: "Friend - ABC",
        image: "https://upload.wikimedia.org/wikipedia/en/1/17/America_album.jpg",
    },
]
